var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { staticClass: "modal-mask", on: { click: _vm.close } }, [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-slideout modal-lg",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _vm.isUserDetailPanel
                  ? _c("div", [
                      _vm.readOnly
                        ? _c(
                            "div",
                            [
                              _c("ViewUserDetailReadonly", {
                                ref: "view_user_readonly",
                                attrs: {
                                  userId: _vm.userId,
                                  accountId: _vm.accountId
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              !_vm.readOnly
                                ? _c("ViewUserDetailManage", {
                                    ref: "view_user_manage",
                                    attrs: {
                                      userId: _vm.userId,
                                      accountId: _vm.accountId
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                    ])
                  : _c("div", [
                      _c("div", { staticClass: "modal-header" }, [
                        _c("div", { staticStyle: { width: "100%" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-uppercase text-muted pt-1",
                              attrs: { href: "javascript:void(0);" },
                              on: { click: _vm.hide }
                            },
                            [
                              _c("img", {
                                staticClass: "back_icon mr-2",
                                attrs: {
                                  src: require("@/assets/manager/back_button_icon.png")
                                }
                              }),
                              _vm._v("Back")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "close float-right",
                              attrs: { type: "button" },
                              on: { click: _vm.hide }
                            },
                            [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("div", { staticClass: "row mb-4" }, [
                          _c("div", { staticClass: "col-9 pl-3" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "h3 d-inline mr-2 text-uppercase col-12 p-0"
                              },
                              [_vm._v(_vm._s(_vm.account.accountName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "h5 mr-2 col-12 p-0",
                                class:
                                  " " + _vm.getFontColor(_vm.account.status)
                              },
                              [_vm._v(_vm._s(_vm.account.status) + " Location")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3 pl-3" }, [
                            !_vm.readOnly
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-sm dbAddNewUserBtn",
                                    staticStyle: {
                                      padding: "5px 25px",
                                      "border-radius": "15px"
                                    },
                                    attrs: { type: "button" },
                                    on: { click: _vm.openNewUserForm }
                                  },
                                  [_vm._v("Add New User")]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 override-padding" },
                          [
                            _c(
                              "div",
                              {
                                class:
                                  "offcanvas_header offcanvas_heading_1" +
                                  (_vm.selectedComponent === "OverviewTab"
                                    ? " active"
                                    : ""),
                                on: {
                                  click: function($event) {
                                    return _vm.tabEvent("OverviewTab")
                                  }
                                }
                              },
                              [_vm._v("Overview")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  "offcanvas_header offcanvas_heading_2" +
                                  (_vm.selectedComponent === "UsersTab"
                                    ? " active"
                                    : ""),
                                on: {
                                  click: function($event) {
                                    return _vm.tabEvent("UsersTab")
                                  }
                                }
                              },
                              [_vm._v("Users")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  "offcanvas_header offcanvas_heading_3" +
                                  (_vm.selectedComponent === "ResourcesTab"
                                    ? " active"
                                    : ""),
                                on: {
                                  click: function($event) {
                                    return _vm.tabEvent("ResourcesTab")
                                  }
                                }
                              },
                              [_vm._v("Resources")]
                            ),
                            _vm._v(" "),
                            !_vm.readOnly
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      "offcanvas_header offcanvas_heading_4" +
                                      (_vm.selectedComponent === "LicenseTab"
                                        ? " active"
                                        : ""),
                                    on: {
                                      click: function($event) {
                                        return _vm.tabEvent("LicenseTab")
                                      }
                                    }
                                  },
                                  [_vm._v("License")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  "offcanvas_header offcanvas_heading_5" +
                                  (_vm.selectedComponent === "ReportsTab"
                                    ? " active"
                                    : ""),
                                on: {
                                  click: function($event) {
                                    return _vm.tabEvent("ReportsTab")
                                  }
                                }
                              },
                              [_vm._v("Reports")]
                            ),
                            _vm._v(" "),
                            !_vm.readOnly
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      "offcanvas_header offcanvas_heading_6" +
                                      (_vm.selectedComponent === "SettingsTab"
                                        ? " active"
                                        : ""),
                                    on: {
                                      click: function($event) {
                                        return _vm.tabEvent("SettingsTab")
                                      }
                                    }
                                  },
                                  [_vm._v("Settings")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { clear: "both" } }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "offcanvas_tab_body" },
                          [
                            _c(_vm.selectedComponent, {
                              ref: _vm.selectedComponent,
                              tag: "component",
                              attrs: {
                                accountId: _vm.accountId,
                                readOnly: _vm.readOnly
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" })
                    ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.readOnly
        ? _c("AddNewUser", {
            ref: "add_new_user",
            attrs: {
              isModalAddUserToLocationVisible:
                _vm.isModalAddUserToLocationVisible,
              accountId: _vm.accountId,
              accountName: _vm.account.accountName
            },
            on: { close: _vm.closeNewUserSidebar }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e0104a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e0104a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/enterpriseadmin_overlay_sidebar.vue
// module id = null
// module chunks = 